const TAG = '[CommitRetryReprice]';

export function logCommitRetryReprice(
  phase: string,
  data?: Record<string, unknown>
): void {
  if (!__DEV__) {
    return;
  }

  // eslint-disable-next-line no-console
  console.info(`${TAG} ${phase}`, {
    t: Date.now(),
    ...data,
  });
}

/** Web only — whether the browser still considers the last tap active for Payment Request. */
export function logUserActivation(phase: string): void {
  if (!__DEV__ || typeof navigator === 'undefined') {
    return;
  }

  const ua = (navigator as Navigator & { userActivation?: { isActive?: boolean } }).userActivation;
  logCommitRetryReprice(phase, {
    userActivationIsActive: ua?.isActive ?? null,
  });
}
